// Images ship inside dist/ (vite copies public/), so they must be resolved
// against wherever THIS bundle was loaded from — static.<base>/plugin/<ver>/,
// localhost:4001 — never a hardcoded domain (#111).
//
// document.currentScript is only set while the loading script is executing, so
// the base is captured here at module evaluation; every caller runs later, when
// it is already null.

export function assetBaseFromScriptSrc(src) {
  if (!src) return null;
  try {
    return new URL('./', src).href;
  } catch {
    return null;
  }
}

const currentScript = typeof document !== 'undefined' ? document.currentScript : null;
const ASSET_BASE = assetBaseFromScriptSrc(currentScript && currentScript.src);

let warned = false;

export function assetUrl(name) {
  if (ASSET_BASE) return ASSET_BASE + 'images/' + name;
  // Only when the bundle is not loaded as a classic <script src> (module
  // script, bundler import). Fail visibly — a page-relative 404 plus one
  // warning — rather than silently pointing at some other host.
  if (!warned) {
    warned = true;
    console.warn(
      '[g8plugin] cannot resolve own bundle URL; load g8plugin.js with a classic <script src>',
    );
  }
  return 'images/' + name;
}
